module.exports = __webpack_public_path__ + "media/educators/ieca-a7116cc3.png";